/* eslint jsx-a11y/no-autofocus: 0 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Icon } from '@scentregroup/ui'
import debounce from 'lodash/debounce'

import style from './index.module.scss'

const DEBOUNCED_WAIT = 200

class SearchModalControls extends Component {
  constructor(props) {
    super(props)
    this.state = { query: props.queryText }
  }

  onQueryChangeDebounced = debounce(() => {
    this.props.onQueryChange(this.state.query)
  }, DEBOUNCED_WAIT)

  onChange = event => {
    this.setState({ query: event.target.value })
    this.onQueryChangeDebounced()
  }

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      // Trigger blur event to dismiss the Keyboard when user clicks Search in iOS.
      window.document.activeElement.blur()
    }
  }

  render() {
    const {
      onQueryKeyDown,
      onSubmit,
      onClickClear,
      onClickClose,
      queryText,
    } = this.props
    return (
      <>
        <button
          aria-label="Close search"
          className={style.closeButton}
          onClick={onClickClose}
        >
          <Icon type="cross" />
        </button>
        <div className={style.inputbar} onSubmit={onSubmit}>
          <form action="#" onSubmit={e => e.preventDefault()}>
            <input
              autoFocus
              id="search-textfield"
              type="search"
              className={style.textfield}
              autoCapitalize="off"
              spellCheck="false"
              autoCorrect="off"
              autoComplete="off"
              placeholder="Enter search"
              value={this.state.query}
              onChange={this.onChange}
              onKeyDown={onQueryKeyDown}
              onKeyPress={this.handleKeyPress}
            />
            <label htmlFor="search-textfield">
              <Icon type="search" className={style.searchIcon} />
            </label>
            {queryText ? (
              <button
                aria-label="Clear search text"
                className={style.clearButton}
                type="button"
                onClick={onClickClear}
              >
                <Icon type="clear" size="small" className={style.clearIcon} />
              </button>
            ) : null}
          </form>
        </div>
      </>
    )
  }
}

SearchModalControls.propTypes = {
  onQueryChange: PropTypes.func,
  onQueryKeyDown: PropTypes.func,
  onSubmit: PropTypes.func,
  onClickClear: PropTypes.func,
  onClickClose: PropTypes.func,
  queryText: PropTypes.string,
}

SearchModalControls.defaultProps = {
  queryText: '',
}

export default SearchModalControls
